export default {
  loading: true,
  error: '',
  mapVisible: false,
  settings: {},
  districts: [],
  seasons: [],
  locations: [],
  productions: [],
  filters: {
    search: null,
    location: null,
    districts: [],
    seasons: []
  },
  highlightedLocation: null
}
